// extracted by mini-css-extract-plugin
export default {"tabLink":"tabLink--dZ7UT","activeTab":"activeTab--wG4h5"};